// @ts-nocheck
import { MODULE_ACL } from "./constant";

/** Permission toggles that should show the Options column and open its modal. */
export const ACL_OPTIONS_TRIGGER_OPS = [
  "view_permission",
  "read",
  "add",
  "edit",
];

/** Module keys that have an Options modal (use MODULE_ACL to avoid circular imports). */
export const ACL_MODULES_WITH_OPTIONS = [
  MODULE_ACL.VOICE_PLANS,
  MODULE_ACL.VOICE_LIBRARY,
  MODULE_ACL.CALL_GROUP,
  MODULE_ACL.AGENTS,
  MODULE_ACL.IVR,
  MODULE_ACL.CALL_CENTRE,
  MODULE_ACL.USERS,
  MODULE_ACL.DISPOSITION_FORMS,
  MODULE_ACL.TTS,
  MODULE_ACL.COMPANY,
  MODULE_ACL.AI_AGENT,
  MODULE_ACL.AGENT_LEADS,
];

export function isAclModuleOptionsRelevant(moduleEntry) {
  if (!moduleEntry) return false;
  return ACL_OPTIONS_TRIGGER_OPS.some((op) => moduleEntry[op] === true);
}

/** True once the user has opened Options and saved (including an explicit empty selection). */
export function areAclEditOptionsConfigured(moduleEntry) {
  return Array.isArray(moduleEntry?.edit_options);
}

export function resolveAclOptionSelection(stored, grantableValues, defaultValues = null) {
  if (Array.isArray(stored)) return stored;
  const grantable = grantableValues || [];
  if (!Array.isArray(defaultValues)) return [...grantable];
  return grantable.filter((value) => defaultValues.includes(value));
}

export function moduleHasConfigurableOptions(moduleName) {
  return ACL_MODULES_WITH_OPTIONS.includes(moduleName);
}

export function shouldOpenAclOptionsModal(moduleName, operation, enabled) {
  if (moduleName === MODULE_ACL.AGENT_LEADS) {
    return enabled && (operation === "read" || operation === "add" || operation === "edit");
  }
  return (
    enabled &&
    ACL_OPTIONS_TRIGGER_OPS.includes(operation) &&
    moduleHasConfigurableOptions(moduleName)
  );
}
